import clsx from "clsx";

export type ErrorTextProps = {
  showError: boolean;
  className?: string;
  height?: string;
  errorMessage: string | null;
};

const ErrorText = ({
  showError,
  className = "",
  height = "h-8",
  errorMessage,
}: ErrorTextProps) => {
  return (
    <label
      className={clsx(
        "text-red mt-1 w-full text-xs font-normal",
        showError ? "visible" : "invisible",
        className,
        height
      )}
    >
      {errorMessage}
    </label>
  );
};

export default ErrorText;
